import React from 'react';
// import PropTypes from 'prop-types';

import {
  detailErrorMsgSelector,
  graphDatesSelector,
  graphParamsSelector,
  graphEntriesSelector,
  intervalSelector,
  idSelector,
  talkersSelector,
  threatsSelector,
  titleSelector,
  windowsEvtsSelector,
} from '../../../selectors/hostSelectors';
import {
  clearDetailErrors,
  fetchGraph,
  fetchTalkers,
  fetchThreats,
  fetchWindowsEvts,
  receiveDateRange,
  redirectToIndex,
} from '../../../redux/actions/Host';
import Detail from './common/Detail';

/*
Component
*/

const HostDetail = () => (
  <Detail
    clearDetailErrors={clearDetailErrors}
    detailErrorMsgSelector={detailErrorMsgSelector}
    fetchTalkers={fetchTalkers}
    fetchThreats={fetchThreats}
    fetchWindowsEvts={fetchWindowsEvts}
    fetchGraph={fetchGraph}
    graphDatesSelector={graphDatesSelector}
    graphEntriesSelector={graphEntriesSelector}
    graphParamsSelector={graphParamsSelector}
    idSelector={idSelector}
    intervalSelector={intervalSelector}
    receiveDateRange={receiveDateRange}
    redirectToIndex={redirectToIndex}
    talkersSelector={talkersSelector}
    threatsSelector={threatsSelector}
    titleSelector={titleSelector}
    windowsEvtsSelector={windowsEvtsSelector}
  />
);

export default HostDetail;
